import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { BehaviorService } from '@_services/Behavior.service';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Component({
  selector: 'app-connection',
  templateUrl: './connection.component.html',
  styleUrls: ['./connection.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectionComponent implements OnInit, OnDestroy {
  ConnectionData: any;
  isspiner: boolean = false;
  selectedIndex: number = 0;
  sub: Subscription;
  sub1: Subscription;
  currentUser: any = JSON.parse(localStorage.getItem('currentUser') || '{}');
  private _unsubscribeAll: Subject<void> = new Subject<void>();

  constructor(
    private toastr: ToastrService,
    private _snackBar: MatSnackBar,
    private behaviorService: BehaviorService,
    private _mainAPiServiceService: MainAPiServiceService,
    private cdr: ChangeDetectorRef,
  ) {}

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit(): void {
    this.getConnection();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
    this.sub?.unsubscribe();
    this.sub1?.unsubscribe();
  }

  /**
   * This function is used to set the index data
   * @param index -index data value
   */
  setIndex(index: number): void {
    this.selectedIndex = index;
    this.cdr.markForCheck();
  }

  /**
   * This unction is used to get the connection data value
   */
  getConnection(): void {
    this.ConnectionData = [];
    this.isspiner = true;
    this.cdr.markForCheck();
    this.sub = this._mainAPiServiceService
      .getSetData(
        {
          Action: 'GetData',
          Filters: { USERGUID: this.currentUser?.UserGuid },
        },
        'oauth-connections',
      )
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (response: any) => {
          if (response.CODE === 200 && response.STATUS === 'success') {
            this.ConnectionData = response.DATA;
            this.isspiner = false;
          } else if (response.CODE == 451 && response.STATUS == 'warning') {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else if (response.CODE == 450 && response.STATUS == 'error') {
            this.isspiner = false;
            this.toastr.error(response.MESSAGE);
          }
          this.cdr.markForCheck();
        },
        error: (error: any) => {
          this.isspiner = false;
          this.toastr.error(error);
          this.cdr.markForCheck();
        },
      });
  }

  /**
   * This function is used to refresh the connection tab data
   */
  refreshConnectionTab(): void {
    this.getConnection();
  }

  /**
   * This function is used to Delete the connection data value
   * @param connection -connection data value.
   * @param index -index data value
   */
  DeleteConnection(connection: any, index: any): void {
    if (connection.STATUS == 'Connected') {
      this.isspiner = true;
      this.cdr.markForCheck();
      this.sub1 = this._mainAPiServiceService
        .getSetData(
          {
            Action: 'Delete',
            DATA: {
              USERGUID: this.currentUser?.UserGuid,
              TokenType: connection.TOKENTYPE,
            },
          },
          'oauth-connections',
        )
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe({
          next: (response: any) => {
            if (response.CODE === 200 && response.STATUS === 'success') {
              this.isspiner = false;
              this.toastr.success('Connection deleted successfully');
              this.refreshConnectionTab();
            } else if (response.CODE == 451 && response.STATUS == 'warning') {
              this.isspiner = false;
              this.toastr.warning(response.MESSAGE);
            } else if (response.CODE == 450 && response.STATUS == 'error') {
              this.isspiner = false;
              this.toastr.error(response.MESSAGE);
            }
            this.cdr.markForCheck();
          },
          error: (error: any) => {
            this.isspiner = false;
            this.toastr.error(error);
            this.cdr.markForCheck();
          },
        });
    } else if (connection.STATUS === 'Disconnected') {
      const payload: any = {
        Action: 'OAuth2Start',
        VALIDATEONLY: false,
        Data: {
          USERGUID: this.currentUser?.UserGuid,
          AuthType: connection.TOKENTYPE,
        },
      };
      const win: Window | null = window.open(
        '',
        'targetWindow',
        `toolbar=no,
      location=no,
     status=no,
     menubar=no,
     scrollbars=yes,
     resizable=yes,
     width=800,
     height=600`,
      );
      if (!win) {
        this.toastr.error('Please allow popups for this site and try again.');
        return;
      }
      this._mainAPiServiceService
        .getSetData(payload, 'oauth-connections')
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe({
          next: (response: any) => {
            if (response.CODE === 200 && response.STATUS === 'success') {
              const authorizationUrl = response.DATA?.[0]?.AuthorizationUrl;
              if (authorizationUrl) {
                win.location.href = authorizationUrl;
              } else {
                win.close();
                this.toastr.error('Authorization URL was not received.');
              }
            } else {
              win.close();
              this.toastr.error(response.MESSAGE || 'Unable to start OAuth authentication.');
            }
            this.cdr.markForCheck();
          },
          error: (error: any) => {
            win.close();
            this.toastr.error(error);
            this.cdr.markForCheck();
          },
        });

      const timer = window.setInterval(() => {
        if (win.closed) {
          window.clearInterval(timer);
          this.getConnection();
        }
      }, 1000);
    }
  }
}
